import { Pipe, PipeTransform } from '@angular/core';
import { Mood } from '@adeo/ngx-kozikaza-api/post';

@Pipe({
  name: 'getPostMoodIcon'
})
export class GetPostMoodIconPipe implements PipeTransform {

  transform(mood: Mood): string {
    return mood.category +'-' + mood.iconName;
  }


}
